(function () {
  'use strict';

  // Respect reduced motion preference
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var phrases = [
    'Rambo Bikes',
    'hunting e-bikes',
    'State Bicycle Co.',
    'fat tire e-bikes',
    'Bakcou',
    'Klunker',
    'Magicycle',
    'mid-drive e-bikes',
    'Cyrusher',
    'full suspension',
    'step-through e-bikes',
    'all-terrain'
  ];

  var config = {
    typeSpeed: 80,
    eraseSpeed: 40,
    pauseAfterType: 2000,
    pauseAfterErase: 500,
    prefix: 'Search for '
  };

  var instances = [];

  // Timer-chain typewriter: wakes only when a character changes, sleeps entirely
  // while the tab is hidden, the input is offscreen, or the input is focused.
  function TypewriterPlaceholder(inputEl) {
    this.input = inputEl;
    this.phraseIndex = Math.floor(Math.random() * phrases.length);
    this.charIndex = 0;
    this.isErasing = false;
    this.timer = null;
    this.focused = false;
    this.inView = true;
    this.originalPlaceholder = inputEl.getAttribute('placeholder') || 'Search...';

    var self = this;
    inputEl.addEventListener('focus', function () {
      self.focused = true;
      self.stop();
      self.input.setAttribute('placeholder', self.originalPlaceholder);
    });
    inputEl.addEventListener('blur', function () {
      self.focused = false;
      self.maybeStart();
    });

    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        self.inView = entries[0].isIntersecting;
        if (self.inView) self.maybeStart();
        else self.stop();
      });
      this.io.observe(inputEl);
    }

    instances.push(this);
    this.maybeStart();
  }

  TypewriterPlaceholder.prototype.stop = function () {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  TypewriterPlaceholder.prototype.maybeStart = function () {
    if (this.timer) return;
    if (this.focused || !this.inView) return;
    if (document.visibilityState === 'hidden') return;
    if (this.input.value !== '') return;
    this.schedule(config.pauseAfterErase);
  };

  TypewriterPlaceholder.prototype.schedule = function (delay) {
    var self = this;
    this.timer = setTimeout(function () {
      self.timer = null;
      self.step();
    }, delay);
  };

  TypewriterPlaceholder.prototype.step = function () {
    var fullText = config.prefix + phrases[this.phraseIndex] + '...';
    var delay;

    if (this.isErasing) {
      this.charIndex--;
      this.input.setAttribute('placeholder', fullText.substring(0, this.charIndex));
      if (this.charIndex <= config.prefix.length) {
        this.isErasing = false;
        this.phraseIndex = (this.phraseIndex + 1) % phrases.length;
        delay = config.pauseAfterErase;
      } else {
        delay = config.eraseSpeed;
      }
    } else {
      this.charIndex++;
      this.input.setAttribute('placeholder', fullText.substring(0, this.charIndex));
      if (this.charIndex >= fullText.length) {
        this.isErasing = true;
        delay = config.pauseAfterType;
      } else {
        delay = config.typeSpeed;
      }
    }

    this.schedule(delay);
  };

  document.addEventListener('visibilitychange', function () {
    for (var i = 0; i < instances.length; i++) {
      if (document.visibilityState === 'hidden') instances[i].stop();
      else instances[i].maybeStart();
    }
  });

  function blockEmptySearch() {
    var forms = document.querySelectorAll('form[action*="/search"]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function (e) {
        var input = this.querySelector('input[name="q"]');
        if (input && input.value.trim() === '') {
          e.preventDefault();
          input.focus();
        }
      });
    }
  }

  function init() {
    blockEmptySearch();
    var selectors = [
      '.search-bar .input-group-field[type="search"]',
      '.site-header__search-input[type="search"]'
    ];
    selectors.forEach(function (sel) {
      var inputs = document.querySelectorAll(sel);
      for (var i = 0; i < inputs.length; i++) {
        new TypewriterPlaceholder(inputs[i]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
